export class GetProviderRequestParams {
    pageNo: number = 1;
    rowPerPage: number = 10;
    filter: string = '';
    bankCode: string = '';
    roleId: string | null = null;
}

export class CreateProviderParams {
  id: string = '';
  name: string = '';
  code: string='';
  user: string = '';
  password: string = '';
  secret_code: string = '';
  base_url: string = '';
  method: string = '';
  inq_param: string = '';
  pay_param: string = '';
  adv_param: string = '';
  reversal_param: string = '';
  inq_url: string = '';
  pay_url: string = '';
  adv_url: string = '';
  reversal_url: string = '';
  callback_url: string = '';
}



export class UpdateProviderRequestParams extends CreateProviderParams {
  oldPassword?: string; 
}
 

export interface ProviderData {
  id: string;
  name: string ;
  user: string ;
  password: string;
  secret_code: string ;
  base_url: string ;
  method: string ;
  inq_param: string ;
  pay_param: string ;
  adv_param: string ;
  reversal_param: string ;
  inq_url: string ;
  pay_url: string ;
  adv_url: string ;
  reversal_url: string;
  code: string;
  callback_url: string;
}


export interface GetProviderResponse {
  code: number;
  message: string;
  data: ProviderData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetProviderByIdResponse {
  code: number;
  message: string;
  data: ProviderData;
}

export interface DeleteProviderByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
